import { useMutation } from '@tanstack/react-query';
import { request } from '../services/request';

export const useAddPCM = () => {
  return useMutation(async (data: { organizationId: string; contactId: string;}) => {
    const jsonResponse = await request({
      data,
      method: 'POST',
      endpoint: 'OrgManager/AddPCM',
    });

    if (!jsonResponse.success) {
      throw new Error(jsonResponse.data?.Message || 'Something went wrong');
    }

    return jsonResponse;
  });
};

